import axios from 'axios'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const baseURL = (config.public.apiBase as string | undefined) || '/api/v3/'

  const bgaAPI = axios.create({
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })

  bgaAPI.interceptors.request.use(
    (req) => {
      const token = `${localStorage.getItem('token')?.replace(/['"]+/g, '')}`
      if (req.headers && token) {
        req.headers.Authorization = `Bearer ${token}`
      }
      return req
    },
    (err) => Promise.reject(err),
  )

  bgaAPI.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      const responseStatus = error?.response?.data?.code
      const redirectOnAuthErr = error?.response?.config?.headers?.['_client_auth_err_redirect'] !== false
      const redirectOnInternalErr = error?.response?.config?.headers?.['_client_internal_err_redirect'] !== false

      if ((status === 403 || status === 401 || responseStatus === 401) && redirectOnAuthErr) {
        setTimeout(() => {
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          window.location.href = '/login'
        }, 1000)
      }

      if (status === 412) {
        // window.location.href = '/not-found';
      }

      if (status === 500 && redirectOnInternalErr) {
        // window.location.href = '/server-error';
      }

      return Promise.reject(error)
    },
  )

  return {
    provide: {
      bgaApi: bgaAPI,
    },
  }
})
